import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n';

/** Подписи периодов в протоколе матча. `0` — серия послематчевых пенальти, а не «нулевой тайм». */
const GAME_PERIOD_LABELS: Record<number, MessageDescriptor> = {
  0: msg`Серия пенальти`,
  1: msg`1-й тайм`,
  2: msg`2-й тайм`,
  3: msg`3-й тайм`,
  4: msg`4-й тайм`,
};

/**
 * Период без подписи — `undefined`, подпись по месту печатает номер. Не путать с `getPeriodLabel`
 * из `shared/utils/period-label.ts` — тот подписывает период на табло трансляции.
 */
export function getGamePeriodLabel(period?: number | null): MessageDescriptor | undefined {
  return period === null || period === undefined ? undefined : GAME_PERIOD_LABELS[period];
}
